<tt-page>
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <form class="form-horizontal sp-0" name="formConsignmentScan" novalidate (ngSubmit)="submitSearch()" method="get" role="form">
                <tt-input ttLabel="consignment_scan" ttFocus [(ttModel)]="barcode" ttShowClearButton [ttButtons]="barcodeButtons"></tt-input>
            </form>

            <tt-button-settings></tt-button-settings>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-button-goto [ttText]="'consignment_list'" [ttGoto]="'consignments'" [ttGotoParms]="{ argtype: '-', argvalue: '-' }"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>
